import { Component, h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import TopicVote from '../topic-list-view/TopicVote'
import TopicComments from '../topic-list-view/TopicComments'
import TopicLastPost from '../topic-list-view/TopicLastPost'
import htmlParser from '../utils/htmlParser'
import Axios from 'axios'
import IdeationStatus from '../topic-list-view/IdeationStatus'
import { IdeaStatus } from '../../control-components/ideation-status/Types'
import { common } from '../common'
import topicUrlGenerator from '../utils/topicUrlGenerator'

type Person = {
  id: string,
  avatar: string,
  username: string,
  reputation: {
      repliesMade: number
  }
}
interface Props {
  contentType: string,
  id: string,
  title: string,
  content: string,
  publicLabel: string,
  tags: Array<string>,
  replyCount: number,
  votes: number,
  voteSet:Array<string>,
  likedBy: Array<string>,
  author: Person,
  lastContributor: Person,
  createdAt: string,
  lastActivityAt: string,
  isGuest: boolean,
  ideaStatus: IdeaStatus,
  currentUserId: number,
  lastPostId: number
}

interface State {
  votes: number,
  currentUserVoted: boolean,
}

class IdeaView extends Component<Props, State> {

  constructor (props: Props) {
    super(props)
    this.state = {
      votes: props.votes,
      currentUserVoted: props.currentUserId !== null && props.voteSet.includes(props.currentUserId.toString())
    }

    this.toggleVoteStatus = this.toggleVoteStatus.bind(this)
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (previousProps.votes !== this.props.votes) {
      this.setState({ votes: this.props.votes })
    }
    if (previousProps.voteSet !== this.props.voteSet) {
      this.setState({ 
        currentUserVoted: this.props.currentUserId !== null && this.props.voteSet.includes(this.props.currentUserId.toString())
      })
    }
  }

  async toggleVoteStatus () {
    if (this.props.isGuest) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    if (this.state.currentUserVoted) {
      this.setState({ currentUserVoted: false, votes: this.state.votes - 1 })
      await Axios.post(`/community/api/ideas/${this.props.id}/unvote`)
    } else {
      this.setState({ currentUserVoted: true, votes: this.state.votes + 1 })
      await Axios.post(`/community/api/ideas/${this.props.id}/vote`)
    }
  }

  render (
    { id, title, content, replyCount, lastActivityAt, lastContributor, author, ideaStatus, lastPostId }: Props,
    { votes, currentUserVoted }: State
  ) {
    const strippedContent = htmlParser.stripHtml(content)

    const ideaUrl = topicUrlGenerator('ideas', title, id)
    const lastPostUrl = lastPostId ? topicUrlGenerator('ideas', title, id, null, lastPostId.toString()) : ideaUrl
    const relativeDate = common.relativeDate(new Date(lastActivityAt).getTime())

    return (
      <div className='topic-view topic-view--ideation idea-view'>
        <a href={ideaUrl} className='topic-view_link' />
        <div className='topic-view_header'>
          <div className='topic-view_header-item'>
            <UserAvatar
              user={{ ...author, ...{ name: author.username } }}
              extraClass='avatar'
              showRank
            />
          </div>
          <div className={'topic-view_header-items-gathered topic-view_header-items_without-category'}>
            <div className='topic-view_header-item'>
              <UserName
                user={author}
                extraClass='username'
              />
              {author.id && author.username ? <span className='user-title text--meta'>{ author.username }</span> : ''}
            </div>
          </div>
        </div>
        <div className='topic-view_info idea-view_info'>
          <div className='topic-view_body-container'>
            <div className='topic-view_body'>
              <h4 className='thread-list-block__title'>
                <a href={ideaUrl} className='qa-topic-title thread-list-block__title-link'>{ title }</a>
                <IdeationStatus topic={{ ideaStatus: ideaStatus }} />
              </h4>
              <p class='thread-list-block__content qa-topic-content'>
                <a href={ideaUrl}>
                  {strippedContent}
                </a>
              </p>
            </div>
            <div className='topic-view_footer'>

              <TopicVote
                currentUserVoted={currentUserVoted}
                numberOfVotes={votes}
                onClick={this.toggleVoteStatus}
              />
              <TopicComments
                numberOfReplies={replyCount}
                id={id}
                lastPostUrl={lastPostUrl}
              />
              <TopicLastPost
                lastPostAuthor={{ ...lastContributor, name: lastContributor.username }}
                lastPostUrl={lastPostUrl}
                lastPostRelativeCreationDate={relativeDate}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default IdeaView
